module.exports = __webpack_public_path__ + "img/5.d654bd84.png";